<template>
  <div class="links">
    <p class="links-label">友情链接</p>
    <div class="links-content">

      <el-link v-for="(item, index) in friendsList"
               :key="index" :href="item.url" target="_blank">{{ item.name }}</el-link>

      <el-link href="#" target="_blank" type="primary">[申请友情连接]</el-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      friendsList: []
    }
  },
  created() {
    this.getFriends()
  },
  methods: {
    getFriends() {
      this.$api.getFriendsLink(res => {
        this.friendsList = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.links {
  padding: 25px 0 35px;
  border-bottom: 1px solid #e8e8e8;

  &-label {
    font-size: 18px;
    color: #333;
  }

  &-content {
    margin-top: 20px;
    a {
      margin-right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/links.vue